var map = {
	"./abdominal.png": 3772,
	"./acuteabdominal.png": 5816,
	"./acutegynecological.png": 6303,
	"./acuteswelling.png": 5924,
	"./altered.png": 7870,
	"./anaphylaxis.png": 4703,
	"./antibiotic.png": 1275,
	"./anuria.png": 8371,
	"./aortic.png": 6995,
	"./aphasia.png": 2174,
	"./backpain.png": 1188,
	"./bleeding.png": 2149,
	"./breastcancer.png": 7850,
	"./chest.png": 4814,
	"./chestwall.png": 3698,
	"./circulatory.png": 8134,
	"./coloncancer.png": 8380,
	"./coronaryheart.png": 6696,
	"./delirium.png": 3860,
	"./dentistry.png": 643,
	"./differentialdiagnosisknown.png": 802,
	"./differentialdiagnosisnotyetknown.png": 8671,
	"./dysphagia.png": 4523,
	"./dyspnea.png": 5485,
	"./dysuria.png": 3198,
	"./embolism.png": 8911,
	"./emergency.png": 2582,
	"./epilepsy.png": 1602,
	"./esophageal.png": 3334,
	"./fever.png": 2411,
	"./flank.png": 7587,
	"./gastrointestinal.png": 7858,
	"./headaches.png": 8951,
	"./hematemesis.png": 6394,
	"./initialassessment.png": 8523,
	"./jaundice.png": 962,
	"./jointpain.png": 1433,
	"./lungcancer.png": 4457,
	"./musculoskeletal.png": 7398,
	"./nausea.png": 6960,
	"./neurological.png": 267,
	"./oncology.png": 7271,
	"./othersymptoms.png": 4727,
	"./pain.png": 850,
	"./paralysis.png": 3695,
	"./pneumothorax.png": 3977,
	"./poisonin &intoxications.png": 2032,
	"./preventive.png": 361,
	"./prostatecancer.png": 2697,
	"./psychiatric.png": 3256,
	"./psychiatry.png": 3003,
	"./psychological.png": 7824,
	"./psychotic.png": 8325,
	"./pulmonarycause.png": 7065,
	"./sepsis.png": 9910,
	"./severe.png": 6513,
	"./stethoscope.png": 26,
	"./suicidalideation.png": 7710,
	"./swelling.png": 824,
	"./thoracic.png": 2390,
	"./trauma.png": 963,
	"./trismus.png": 1738,
	"./urogenital.png": 6019,
	"./vertigo.png": 1809,
	"./vision.png": 2425,
	"./vitals.png": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;